import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { AccountInfo } from '@azure/msal-browser';
import { useLazyValidateUserQuery } from '../../services/MVPAuthService';
import { useAlertHelper } from '../../utils/functions/hooks';
import { useAuthHelper } from '../../utils/functions/authentication';
import { useDispatch } from 'react-redux';

import { showRefresh } from '../../services/features/refreshSlice';

export const useLoginHelper = () => {
  const { instance, accounts } = useMsal();
  const dispatch = useDispatch();
  const { refreshToken } = useAuthHelper();
  const [validateUser, { data: userValidation }] =
    useLazyValidateUserQuery();
  const { showError } = useAlertHelper();
  const advantaUserAuthentication = async ({
    username,
  }: AccountInfo) => {
    try {
      const res = await validateUser(username).unwrap();
      const validateUserRes = res?.data?.ValidateUser;

      if (
        validateUserRes?.responseStatus?.status !==
        'SUCCESS'
      ) {
        dispatch(
          showRefresh({
            title: true,
          })
        );
      }
    } catch {
      showError('User Validation failed');
    }
  };

  useEffect(() => {
    const authenticateUser = async () => {
      // if (!instance) {
      //   console.error('MSAL instance is not available');
      //   return;
      // }

      // // Ensure MSAL is initialized before proceeding
      // await instance.initialize();

      const userProfile = accounts[0];

      if (userProfile) {
        await refreshToken();
        advantaUserAuthentication(userProfile);

        const timer = setInterval(refreshToken, 900000); // Refresh token every 10 minutes
        return () => clearInterval(timer);
      } else {
        try {
          const { account: userProfile } =
            await instance.acquireTokenSilent({
              account: accounts[0],
              scopes: ['User.Read'],
            });
          advantaUserAuthentication(userProfile);
        } catch {
          console.error('Silent authentication failed');
        }
      }
    };

    authenticateUser();
  }, [accounts, instance]);

  return userValidation?.data?.ValidateUser;
};
